import type { ProbateAnswers } from "@/shared/types/probateTypes";

export const PROBATE_FORMS = {
  P1: "P-1",
  P3: "P-3",
  P4: "P-4",
  P5: "P-5",
  P6: "P-6",
  P7: "P-7",
  P8: "P-8",
  P9: "P-9",
  P10: "P-10",
} as const;

export type ProbateFormId = (typeof PROBATE_FORMS)[keyof typeof PROBATE_FORMS];

export const PROBATE_FORM_NAMES: Record<ProbateFormId, string> = {
  "P-1": "Petition for Probate",
  "P-3": "Affidavit of Attesting Witness",
  "P-4": "Waiver of Process; Consent to Probate",
  "P-5": "Citation",
  "P-6": "Notice of Probate",
  "P-7": "Affidavit of Service of Citation",
  "P-8": "Petition to Dispense with Testimony of Attesting Witness",
  "P-9": "Affidavit Proving Handwriting of Testator / Witness",
  "P-10": "Renunciation of Nominated Executor",
};

export const PROBATE_FORM_URLS: Record<ProbateFormId, string> = {
  "P-1": "/probate/new_york/P-1_Petition_for_Probate.pdf",
  "P-3": "/probate/new_york/P-3_Affidavit_of_Attesting_Witness.pdf",
  "P-4": "/probate/new_york/P-4_Waiver_of_Process_Consent_to_Probate.pdf",
  "P-5": "/probate/new_york/P-5_Probate_Citation.pdf",
  "P-6": "/probate/new_york/P-6_Notice_of_Probate.pdf",
  "P-7": "/probate/new_york/P-7_Affidavit_of_Service_of_Citation.pdf",
  "P-8": "/probate/new_york/P-8_Application_and_Order_to_Dispense_with_Witness_Testimony.pdf",
  "P-9": "/probate/new_york/P-9_Affidavit_Proving_Handwriting.pdf",
  "P-10": "/probate/new_york/P-10_Renunciation_of_Nominated_Executor_Trustee.pdf",
};

export function getRequiredForms(answers: ProbateAnswers): ProbateFormId[] {
  if (answers.will_location === "safe_deposit_box") {
    return [PROBATE_FORMS.P1, PROBATE_FORMS.P6];
  }

  const forms: ProbateFormId[] = [PROBATE_FORMS.P1, PROBATE_FORMS.P6];

  if (answers.executor_status === "successor_willing") {
    forms.push(PROBATE_FORMS.P10);
  }

  if (answers.heir_consents) {
    const consents = Object.values(answers.heir_consents);

    if (consents.includes("willing_to_sign")) {
      forms.push(PROBATE_FORMS.P4);
    }

    if (
      consents.includes("uncooperative") ||
      consents.includes("minor_or_incapacitated") ||
      consents.includes("cannot_locate")
    ) {
      forms.push(PROBATE_FORMS.P5);
    }

    if (consents.includes("uncooperative") || consents.includes("cannot_locate")) {
      forms.push(PROBATE_FORMS.P7);
    }
  }

  if (answers.witness_status) {
    const raw = answers.witness_status;
    const statuses = typeof raw === "string" ? [raw] : Object.values(raw);

    if (statuses.includes("can_sign")) {
      forms.push(PROBATE_FORMS.P3);
    }

    if (statuses.includes("unavailable")) {
      forms.push(PROBATE_FORMS.P8);
      forms.push(PROBATE_FORMS.P9);
    }
  }

  return [...new Set(forms)];
}
